<template>
  <v-dialog v-model="dialogLog" max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        icon
        class="ma-0 mr-0 pa-0 ml-0 hidden-md-and-down"
        dark
        color="secondary"
        @click.stop="showLog()"
        v-on="on"
      >
        <v-icon>history</v-icon>
      </v-btn>
    </template>

    <v-card class="pa-4">
      <v-card-title class="pa-0 pb-2">
        <h2>{{task.name}}</h2>
      </v-card-title>
      <v-card-text class="pa-0 pt-1">
        <CaseTaskRunHistoryRow v-for="(row, index) in history" :key=index :event=row></CaseTaskRunHistoryRow>
      </v-card-text>
      <v-card-actions class="ma-0 pa-0 pt-1 d-block">
        <v-btn @click="dialogLog = false" color="secondary">Close</v-btn>
        <v-btn @click="markResolved" color="error" v-if="needsResolving">Mark Resolved</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CaseTaskRunHistoryRow from './CaseTaskRunHistoryRow.vue'
import { mapState } from 'vuex'

export default {
  name: "CaseTaskRunHistory",
  components: {CaseTaskRunHistoryRow}, 
  props: { task: { type: Object, required: true } },
  data: () => ({
    dialogLog: false,
  }),
  computed: {
    needsResolving() {
      return this.task && this.task.unresolvedFailures > 0
    },
    ...mapState({ history: state => state.cases.currentlySelected.taskHistory })
  },
  methods: {
    async showLog() {
      await this.$store.dispatch("showCaseTaskRunHistory", this.task) 
      this.dialogLog = true
    },
    async markResolved() {
      await this.$store.dispatch("resolveTaskFailures", this.task) 
    }
  }
}
</script>
